import { StyledEngineProvider } from "@mui/material/styles";
import dotenv from "dotenv";
import React from "react";
import ReactDOM from "react-dom/client";
import { usePromiseTracker } from "react-promise-tracker";
import SimpleReactLightbox from "simple-react-lightbox";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from "./components/ScrollToTop";
import SubsHeader from "./components/SubsHeader";

dotenv.config();
const LoadingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    // promiseInProgress &&
    // <div
    //   style={{
    //    width: "100%",
    //    height: "100",
    //    display: "flex",
    //    justifyContent: "center",
    //    alignItems: "center"
    //   }}
    //  >
    // <Loader type="Rings" color="#0E3F51" height="100" width="100" />
    // </div>
    null
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.Fragment>
    <SimpleReactLightbox>
      <StyledEngineProvider injectFirst>
        <div id="back-to-top-anchor" />
        <div id="subsHeader" ></div>
        <App />
        <ScrollToTop />
       
      </StyledEngineProvider>
    </SimpleReactLightbox>
    {/* <LoadingIndicator /> */}
  </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
